var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCelebration = function SvgCelebration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D1B",
    d: "M58.429 10.612 52.5 16.103l8.238 2.673 4.68-.905 1.249-4.584zM41.667 26.714l8.238 2.674 4.564-.797 1.364-4.698-8.24-2.669z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D1B",
    d: "M55.952 23.673 50 29.162l8.27 2.675 5.063-5.778zM72.5 15.08l-5.973-2.019-5.694 5.492 7.906 2.671z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74CAFC",
    d: "M68.66 0 62.5 5.805l2.998 8.073 4.227-.356 1.942-5.452zM52.5 16.426l2.728 8.064 3.533-.042 2.072-5.772-2.728-8.064zM41.667 27.03l2.727 8.072 3.586-.094L50 29.284l-2.727-8.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74CAFC",
    d: "m55 24.582 3.001 8.071 6.166-5.806-3.001-8.071zM44.167 35.197l2.73 8.068 5.603-5.809-2.732-8.068-5.601 5.81zM71.444 8.163l-5.61 5.81 2.725 8.068 5.608-5.81z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.917,
    cy: 14.286,
    fill: "#3DA1DB",
    rx: 2.083,
    ry: 2.041
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.583,
    cy: 3.673,
    fill: "#3DA1DB",
    rx: 2.083,
    ry: 2.041
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3DA1DB",
    d: "m69.167 72.653-2.084-.863-2.083.863.878-2.04L65 68.572l2.083.863 2.084-.863-.879 2.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D1B",
    d: "m45.833 8.98-3.75-1.553-3.75 1.553 1.583-3.674-1.583-3.673 3.75 1.552 3.75-1.552-1.585 3.673zM80 68.571l-3.75-1.55-3.75 1.55 1.585-3.673-1.585-3.674 3.75 1.553L80 61.224l-1.585 3.674zM17.412 4.898 15 12.298l5.924 4.845 2.41-7.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3DA1DB",
    d: "m69.167 32.631 4.354 4.104 5.646-2.425-4.355-4.106zm-46.723-9.774-3.84 9.824-.224 6.946-3.614 2.877-3.84 9.823-.72 8.214-3.118 1.612L0 80l17.768-6.82 2.796-3.737 6.72-.227 9.515-3.964 3.935-2.76 5.584-1.204 9.515-3.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D1B",
    d: "m32.759 46.994-13.906-14.34L15 42.5l11.057 11.404v-.003.003l11.057 11.401 9.553-3.974zM19.4 60.51l-8.098-8.265L7.5 61.86l5.288 5.396 5.289 5.396 9.423-3.88z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.583,
    cy: 41.224,
    fill: "#FF9D1B",
    rx: 2.083,
    ry: 2.041
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.083,
    cy: 58.776,
    fill: "#74CAFC",
    rx: 2.083,
    ry: 1.633
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3DA1DB",
    d: "m48.333 44.963 3.843 3.804c7.465-2.817 15.966-1.13 21.643 4.294l3.681-3.52c-7.693-7.344-19.423-9.186-29.167-4.578"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74CAFC",
    d: "m30.658 27.876 3.735 3.96c5.354-9.885 3.669-22.203-4.131-30.203l-3.595 3.68c5.79 5.936 7.38 14.925 3.991 22.563"
  }))));
};
export default SvgCelebration;